import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../../Context/DataContext';
import PageHeader from '../../components/PageHeader/PageHeader';
import MetricRow from '../../components/MetricRow/MetricRow';
import MetricCard from '../../components/MetricCard/MetricCard';
import Button from '../../components/Button/Button';
import styles from './Payments.module.css';

const Payments = () => {
  const [activeTab, setActiveTab] = useState('batches');
  const { failedPayoutsCount } = useData();

  const batches = [
    {
      id: 'PB-0929',
      study: 'Gaming focus group – Batch 1',
      participants: 8,
      amount: '₹40,000',
      status: { label: 'Awaiting approval', color: '#6A4A00', bg: '#FFF9E6' },
      link: '/payout-batch',
      linkText: 'Review →'
    },
    {
      id: 'PB-0928',
      study: 'Footwear CLT – Day 1',
      participants: 12,
      amount: '₹7,200',
      status: { label: 'Awaiting approval', color: '#6A4A00', bg: '#FFF9E6' },
      link: '/payout-batch',
      linkText: 'Review →'
    },
    {
      id: 'PB-0921',
      study: 'Smartphone diary study',
      participants: 96,
      amount: '₹28,800',
      status: { label: 'Paid', color: '#007A21', bg: '#DCFFE5' },
      link: '/payout-batch',
      linkText: 'View'
    },
    {
      id: 'PB-0918',
      study: 'HR & IT Managers',
      participants: 6,
      amount: '₹6,000',
      status: { label: `${failedPayoutsCount} failed`, color: '#B3261E', bg: '#FFF0EF' },
      link: '/failed-payouts',
      linkText: 'Fix →'
    }
  ];

  const headerActions = (
    <Button
      variant="secondary"
      onClick={() => alert('Ledger downloaded.')}
    >
      Download ledger
    </Button>
  );

  return (
    <>
      <PageHeader
        title="Payments"
        subtitle="Participant payouts, researcher top-ups and refunds."
        actions={headerActions}
      />

      <MetricRow columns={4}>
        <MetricCard label="Due for approval" value="₹47,200" subtext="2 batches" />
        <MetricCard label="Paid this month" value="₹18.4L" subtext="to 2,140 participants" isGreen />
        <MetricCard label="Failed payouts" value={failedPayoutsCount} subtext="₹3,000 on hold" />
        <MetricCard label="Top-ups this month" value="₹22.9L" subtext="from researchers" />
      </MetricRow>

      <div className={styles.tabsRow}>
        <button
          type="button"
          onClick={() => setActiveTab('batches')}
          className={`${styles.tabLink} ${activeTab === 'batches' ? styles.tabLinkActive : ''}`.trim()}
        >
          Payout batches
        </button>
        <button
          type="button"
          onClick={() => setActiveTab('topups')}
          className={`${styles.tabLink} ${activeTab === 'topups' ? styles.tabLinkActive : ''}`.trim()}
        >
          Top-ups
        </button>
        <button
          type="button"
          onClick={() => setActiveTab('refunds')}
          className={`${styles.tabLink} ${activeTab === 'refunds' ? styles.tabLinkActive : ''}`.trim()}
        >
          Refunds
        </button>
        <button
          type="button"
          onClick={() => setActiveTab('provider')}
          className={`${styles.tabLink} ${activeTab === 'provider' ? styles.tabLinkActive : ''}`.trim()}
        >
          Payout provider
        </button>
      </div>

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Batch</div>
          <div>Study</div>
          <div>Participants</div>
          <div>Amount</div>
          <div>Status</div>
          <div></div>
        </div>

        {batches.map((batch) => (
          <div key={batch.id} className={styles.tableRow}>
            <div>
              <span className={styles.batchId}>{batch.id}</span>
            </div>
            <div className={styles.cellText}>{batch.study}</div>
            <div className={styles.cellText}>{batch.participants}</div>
            <div className={styles.cellText} style={{ fontWeight: 500 }}>{batch.amount}</div>
            <div>
              <span
                className={styles.badge}
                style={{ color: batch.status.color, background: batch.status.bg }}
              >
                {batch.status.label}
              </span>
            </div>
            <div>
              <Link to={batch.link} className={styles.actionLink}>
                {batch.linkText}
              </Link>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default Payments;
